const MenuAlignments = Object.freeze({
  Right: "right",
  Left: "left",
} as const);

export type MenuAlignment =
  (typeof MenuAlignments)[keyof typeof MenuAlignments];

export const MenuAlignmentOptions: MenuAlignment[] =
  Object.values(MenuAlignments);

export default MenuAlignments;
